import { Component, OnInit } from '@angular/core';
import { CourseService } from '../../Services/course.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../Services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-course-view',
  template: require('./course-view.component.html'),
  styles: [require('./course-view.component.css')]
})


export class CourseViewComponent implements OnInit {

  currentID: number = -1
  currentCourse: any = {
    "id": -1,
    "name": "",
    "distance": 0,
    "url": "",
    "courseNr": -1,
    "longDescription": null,
    "shortDescription": null,
    "altitudeMeters": 0,
    "gr": 0,
    "fileName": "",
    "fileLastUpdate": "",
    "courseCategory": {
        "id": -1,
        "category": ""
    },
    "courseCategoryId": -1,
    "hidden": false,
    "extraInfo": null
}


  loggedInUser: boolean = false;
  constructor(private route: ActivatedRoute, private courseService: CourseService, private auth: AuthService) {
    route.params.subscribe(p => {
      if (p["id"]) this.currentID = +p["id"];
      else this.currentID = -1;
    });
  }

  ngOnInit() {
    this.courseService.getCourse(this.currentID).subscribe( (c:any) =>{
      this.currentCourse = c;
      console.log(this.currentCourse);
      
    } )   
    this.loggedInUser = this.auth.isAuthenticated();
  }
  
  CopyLinkToClipboard(){
    var cpLink = window.location.href;
  
    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(cpLink);
    Swal.fire({
      text: "Link gekopieerd naar het clipboard",
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/course-view/course-view.component.ts